/* eslint-disable camelcase */
// import React from 'react';
import {
  createGridMetaFromDocument,
  extractGridMetaFromTab,
  generateTab
} from '../../../utils';
import {
  getDefaultColumns,
  getMetaGridDefaultCol,
  getWorkflowStateColumns,
  getWorkflowStateMetaGridCols
} from '../../../config/constants/columnDefinitions';
import {
  WorkflowState,
  WorkflowStateCollection,
  WorkflowStateDocumentType
} from '@digitalworkflow/dwtranslateclient';
import { portalInfo } from '../../../config/constants/portalInfo';
import {
  ITabParams,
  CellValueChangedEvent,
  ColDef,
  GridApi,
  GridMetaData
} from '../../../config/types';
import { builderPageTypes } from '../../../config/constants/builderPageTypes';
import { updateCurrentGridDetail } from '../../CurrentGridDetail/updateCurrentGridDetail';
import { GlobalHashHelper } from '../../../utils/HashHelper';

/**
 * @return Promise<boolean>
 * @returns true - if lookup is updated successfully
 * @returns false - if lookup is not updated successfully
 */
async function updateWorkflowState(
  id: string,
  data: WorkflowStateDocumentType
): Promise<WorkflowState | false> {
  const res = await WorkflowStateCollection.updateWorkflowState(id, data);
  return res && res.saveResults.did_save && res.record;
}

export async function openWorkflowStatesTab({
  ref,
  data: workflowStates,
  groups,
  rows,
  title,
  firstTab = true,
  gridReferences,
  updateMetaData,
  fetchData,
  setSelectedRows,
  setSelectedRowIndex,
  setCurrentEventAPI,
  setRowSelectedFlag,
  setTabsRef,
  updateData
}: ITabParams) {
  if (!ref) {
    console.log('no ref provided, returning...');
    return;
  }

  const defaultColDef: ColDef = getDefaultColumns(
    portalInfo.agGridConfig.sortableColumn
  );

  const columnDefs: ColDef[] = getWorkflowStateColumns(updateData);

  let data: Partial<WorkflowStateDocumentType>[] = [];
  let key: string = '';

  if (firstTab) {
    if (!workflowStates?.length) {
      console.log('WFS in redux empty, returning...');
      return;
    }

    const currentWorkflow: WorkflowState = GlobalHashHelper.hasOption('tab')
      ? workflowStates.find(
          (item: WorkflowState) =>
            item.data.name ===
            GlobalHashHelper.getOption('tab').replaceAll('%20', ' ')
        )
      : workflowStates[0];

    data = [currentWorkflow.data];
    key = currentWorkflow.data.name as string;
  } else {
    if (!rows || !title) {
      console.log('rows||title WFS empty, returning...');
      return;
    }

    key = title;
    data = [...rows];
  }
  function onUpdateAPI(api: GridApi) {
    if (api.getSelectedRows() && api.getSelectedRows().length > 0) {
      setSelectedRows?.(api.getSelectedRows());
      setRowSelectedFlag(true);
    }
    setCurrentEventAPI(api);
  }
  /**
   * last row edit - creates new row, add lookup in DB
   * other row edit - edits current row, edit lookup in DB
   * delete all cells data - deletes object from DB
   * @param e event triggred on cell value change
   */
  async function onCellValueChanged(e: CellValueChangedEvent) {
    setSelectedRows([e.data]);
    return await updateWorkflowState(e.data.id, e.data);
  }

  async function localCellValueChanged(e: CellValueChangedEvent) {
    const isUpdated = await onCellValueChanged(e);
    if (!isUpdated || !ref) return;

    fetchData();

    const newGridMeta: GridMetaData = createGridMetaFromDocument(isUpdated);

    updateCurrentGridDetail({
      type: builderPageTypes.workflowStates,
      ref,
      data: newGridMeta
    });
  }

  const workflowStateData = await WorkflowStateCollection.getWorkflowStateById(
    data[0].id ?? ''
  );
  const gridMetaData: GridMetaData | undefined =
    workflowStateData && createGridMetaFromDocument(workflowStateData);

  const metaGridCols = getWorkflowStateMetaGridCols();
  const metaGridDefaultCol = getMetaGridDefaultCol();

  const tab = generateTab({
    id: key,
    title: key,
    group: builderPageTypes.workflowStates,
    data: data,
    theme: portalInfo.agGridConfig.theme,
    pagination: portalInfo.agGridConfig.pagination,
    defaultColDef,
    columnDefs,
    masterDetail: true,
    // detailCellRendererParams,
    gridReferences,
    gridMetaData,
    metaGridCols,
    metaGridDefaultCol,
    onCellValueChanged: (e: CellValueChangedEvent) => localCellValueChanged(e),
    setSelectedRowIndex,
    onUpdateAPI: (api: GridApi) => onUpdateAPI(api),
    setTabsRef,
    onMetaCellValueChanged: (e: CellValueChangedEvent) => {
      updateMetaData && updateMetaData(e.data);
    },
    dockRef: ref
  });

  console.log(groups, data, title);

  if (firstTab) {
    ref.updateTab('Loading', tab, true);

    updateCurrentGridDetail({
      type: builderPageTypes.workflowStates,
      ref,
      data: extractGridMetaFromTab(ref, key + '_tab')
    });
  } else {
    ref.dockMove(tab, 'grid_dock', 'middle');
  }
}
